import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import StockoutreqDashboard from '../StockoutreqDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import StockoutreqPageImpl from './StockoutreqPageImpl';

export default function StockoutreqPage() {
    const {mobileView} = useSelector((state)=>state.menu);
    const dispatch = useDispatch();
    const { stockoutreqList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':!mobileView}));
    },[]);

    return (
        < StockoutreqPageImpl />
    )

}